export const MANAGER_PASSWORD = "admin123";

export const getDeviceID = (): string => {
  const navigator_info = window.navigator;
  const screen_info = window.screen;
  let uid = navigator_info.mimeTypes.length.toString();
  uid += navigator_info.userAgent.replace(/\D+/g, "");
  uid += navigator_info.plugins.length.toString();
  uid += screen_info.height.toString() || "";
  uid += screen_info.width.toString() || "";
  uid += screen_info.pixelDepth.toString() || "";
  return uid;
};
